import { useMutation } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { AxiosError } from "axios";

async function deleteDevice(id: number): Promise<void> {
    try {
        await ApiClient({ url: `/devices/${id}`, method: "DELETE" });
    } catch (error: any) {
        throw new Error(error instanceof AxiosError ? error.response?.data?.error : "An error occurred while deleting the device.");
    }
}

export function useDeleteDeviceMutation(onSuccess: () => void, onError: (error: Error) => void) {
    return useMutation<void, Error, number>({
        mutationKey: ["delete-device"],
        mutationFn: deleteDevice,
        onSuccess: onSuccess,
        onError: onError
    });
}
